import { useMediaQuery, useTheme } from "@mui/material";

/**
 * Below `md`: the rail becomes a drawer and the shells drop their nav offset.
 *
 * Reads the theme so the value lives in one place (`theme/outpaveTheme.ts`).
 * Do not reintroduce a literal here: a hand-written `(max-width: 900px)` and
 * `breakpoints.down("md")` disagree at exactly 900px, because MUI subtracts a
 * fraction so `up` and `down` cannot both match.
 */
export const useIsSmallScreen = () => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down("md"));
};

/**
 * `md` to `lg`: wide enough for a rail, too narrow to spend 240px on one, so
 * it is pinned to the icon strip and the toggle is hidden.
 */
export const useIsTabletScreen = () => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.between("md", "lg"));
};
